<template>
  <div
    class="netpa-tab"
    :class="{ 'is-stacked': Stacked }"
    :style="{ marginBottom: '-' + Gap + 'px' }"
    dir="rtl"
  >
    <div class="netpa-tab__strip">
      <div class="netpa-tab__scroller" ref="Scroller">
        <!-- شکل تب فعال: پس‌زمینه‌ی هدر NetPaCard را کپی می‌کند تا به کارت بچسبد -->
        <div
          v-if="Shape"
          class="netpa-tab__shape"
          :style="Shape.box"
          aria-hidden="true"
        >
          <div class="netpa-tab__fill" :style="Shape.fill"></div>
        </div>
        <ul class="nav netpa-tab__list" role="tablist">
          <li v-for="(tab, index) in Tabs" :key="tab.id" class="netpa-tab__item">
            <a
              class="netpa-tab__link"
              :class="IsActive(tab, index) ? 'active' : ''"
              :id="tab.id + '-tab'"
              data-toggle="tab"
              :href="'#' + tab.id"
              role="tab"
              :aria-controls="tab.id"
              :aria-selected="IsActive(tab, index) ? 'true' : 'false'"
              >{{ tab.title }}</a
            >
          </li>
        </ul>
      </div>
      <!-- وقتی تب‌ها جا نمی‌شوند، فلش‌ها نشان می‌دهند که از کدام طرف تب پنهان هست -->
      <button
        v-show="CanRight"
        type="button"
        class="netpa-tab__arrow netpa-tab__arrow--right"
        :class="{ 'is-hint': Hint }"
        tabindex="-1"
        aria-label="تب‌های قبلی"
        @click="ScrollBy(1)"
      >
        <i>
          <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
            <path d="M6 3l5 5-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>        </i>
      </button>
      <button
        v-show="CanLeft"
        type="button"
        class="netpa-tab__arrow netpa-tab__arrow--left"
        :class="{ 'is-hint': Hint }"
        tabindex="-1"
        aria-label="تب‌های بعدی"
        @click="ScrollBy(-1)"
      >
        <i>
          <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
            <path d="M10 3l-5 5 5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>        </i>
      </button>
    </div>
    <div class="netpa-tab__actions" ref="Actions"><slot></slot></div>
  </div>
</template>
<script>
/*
  استفاده:
  <net-pa-tab :Tabs="[{ id: 'nav-home', title: 'عنوان' }]" @change="id => ...">
    دکمه‌های کنار تب‌ها (اختیاری)
  </net-pa-tab>
  رویداد change بعد از هر تغییر تب، id پنل فعال را می‌دهد
  <net-pa-card> ... </net-pa-card>   <- حتماً بلافاصله بعد از تب
  یا یک <div class="tab-content"> که اولین عنصر هر پنل آن یک net-pa-card است
  اگر عنوان کارت با عنوان تب تکراری است، هدر کارت را فشرده و بدون عنوان بسازید
  (گرادیان هدر می‌ماند و خود تب نقش عنوان را دارد):
  <net-pa-card :Compact="true"> ... </net-pa-card>

  پنل‌ها همان tab-pane بوت‌استرپ هستند و id آن‌ها باید با id تب برابر باشد:
  <div class="tab-content">
    <div class="tab-pane fade show active" id="nav-home">...</div>
  </div>
*/
export default {
  name: "NetPaTab",
  data() {
    return {
      Shape: null,
      Gap: 8,
      CanLeft: false,
      CanRight: false,
      Hint: false,
      Stacked: false,
    };
  },
  // Active (اختیاری): id تبی که در شروع فعال است؛ پیش‌فرض اولین تب
  props: ["Tabs", "Radius", "Active"],
  computed: {
    R() {
      return this.Radius ? Number(this.Radius) : 14;
    },
  },
  watch: {
    Tabs() {
      this.$nextTick(this.Sync);
    },
  },
  methods: {
    IsActive(tab, index) {
      return this.Active ? tab.id == this.Active : index == 0;
    },
    // با شروع تغییر تب (مثل کلیک): id پنل جدید را emit می‌کند
    OnShow(e) {
      const href = e && e.target ? e.target.getAttribute("href") : "";
      this.$emit("change", href ? href.replace("#", "") : "");
    },
    // کارتی که تب به آن می‌چسبد:
    // یا خود عنصر بعدی است، یا اولین کارت پنل فعال داخل tab-content
    GetCard() {
      const next = this.$el.nextElementSibling;
      if (!next) return null;
      if (next.classList.contains("netpa-card")) return next;
      return (
        next.querySelector(".tab-pane.active .netpa-card") ||
        next.querySelector(".netpa-card")
      );
    },
    GetHeader() {
      const card = this.GetCard();
      return card ? card.querySelector(".netpa-card__header") : null;
    },
    // جهت فیزیکی (چپ/راست) با rect حساب می‌شود تا به مدل scrollLeft مرورگر در RTL وابسته نباشد
    UpdateArrows() {
      const scroller = this.$refs.Scroller;
      const list = this.$el.querySelector(".netpa-tab__list");
      if (!scroller || !list) return;
      const box = scroller.getBoundingClientRect();
      const content = list.getBoundingClientRect();
      this.CanLeft = content.left < box.left - 1;
      this.CanRight = content.right > box.right + 1;
    },
    // یک بار در شروع: نوار کمی به سمت تب‌های پنهان می‌لغزد و برمی‌گردد
    // تا کاربر بفهمد قابل اسکرول است
    PeekHint() {
      if (this.Hinted) return;
      this.UpdateArrows();
      if (!this.CanLeft && !this.CanRight) return;
      this.Hinted = true;
      this.Hint = true;
      this.HintTimer = setTimeout(() => (this.Hint = false), 2400);
      if (
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      )
        return;
      const scroller = this.$refs.Scroller;
      if (!scroller.scrollBy) return;
      const step = (this.CanLeft ? -1 : 1) * 56;
      scroller.scrollBy({ left: step, behavior: "smooth" });
      this.PeekTimer = setTimeout(() => {
        scroller.scrollBy({ left: -step, behavior: "smooth" });
      }, 550);
    },
    // dir=1 به راست، dir=-1 به چپ
    ScrollBy(dir) {
      const scroller = this.$refs.Scroller;
      const step = Math.max(scroller.clientWidth * 0.7, 120) * dir;
      if (scroller.scrollBy) {
        scroller.scrollBy({ left: step, behavior: "smooth" });
      } else {
        scroller.scrollLeft += step;
      }
    },
    // اگر تب‌ها و دکمه‌ها کنار هم جا نشوند، دکمه‌ها بالای تب‌ها می‌روند
    // اندازه‌ها مستقل از چیدمان فعلی گرفته می‌شوند تا بین دو حالت نوسان نکند
    UpdateStacked() {
      const actions = this.$refs.Actions;
      const list = this.$el.querySelector(".netpa-tab__list");
      const buttons = actions ? Array.from(actions.children) : [];
      if (!list || buttons.length === 0) {
        this.Stacked = false;
        return;
      }
      const prev = list.style.minWidth;
      list.style.minWidth = "0";
      const tabsW = list.offsetWidth;
      list.style.minWidth = prev;
      const actionsW =
        buttons.reduce((sum, b) => sum + b.offsetWidth, 0) +
        (buttons.length - 1) * 8;
      this.Stacked = tabsW + actionsW + 16 + 8 > this.$el.clientWidth;
    },
    Sync() {
      this.UpdateStacked();
      this.UpdateArrows();
      const card = this.GetCard();
      const header = this.GetHeader();
      const active = this.$el.querySelector(".netpa-tab__link.active");
      if (!card || !header || !active) return;
      // کارت بالا نپرد تا درز تب و کارت باز نشود
      card.style.transform = "none";
      this.Gap = parseFloat(getComputedStyle(card).marginTop) || 0;

      const r = this.R;
      const scroller = this.$refs.Scroller;
      const box = scroller.getBoundingClientRect();
      const tab = active.getBoundingClientRect();
      const head = header.getBoundingClientRect();
      // لبه‌ی چپ شکل روی صفحه؛ مختصات داخل اسکرولر با scrollLeft جبران می‌شود
      const screenLeft = tab.left - r;
      const w = tab.width + r * 2;
      // یک پیکسل روی border بالای کارت می‌نشیند
      const h = tab.height + 1;
      const shape = {
        box: {
          left: screenLeft - box.left + scroller.scrollLeft + "px",
          top: tab.top - box.top + scroller.scrollTop + "px",
          width: w + "px",
          height: h + "px",
        },
        fill: {
          backgroundImage: getComputedStyle(header).backgroundImage,
          // هدر فشرده (Compact) از تب کوتاه‌تر است؛ گرادیان باید کل تب را بپوشاند
          backgroundSize:
            header.clientWidth + "px " + Math.max(header.clientHeight, h) + "px",
          backgroundPosition: head.left - screenLeft + "px 0",
          clipPath:
            "path('M0 " + h +
            " A" + r + " " + r + " 0 0 0 " + r + " " + (h - r) +
            " L" + r + " " + r +
            " A" + r + " " + r + " 0 0 1 " + r * 2 + " 0" +
            " L" + (w - r * 2) + " 0" +
            " A" + r + " " + r + " 0 0 1 " + (w - r) + " " + r +
            " L" + (w - r) + " " + (h - r) +
            " A" + r + " " + r + " 0 0 0 " + w + " " + h + " Z')",
        },
      };
      const key = JSON.stringify(shape);
      if (key === this.LastShape) return;
      this.LastShape = key;
      this.Shape = shape;
    },
    // تب فعال را داخل نوار اسکرول‌شونده قابل دیدن می‌کند
    Reveal() {
      const scroller = this.$refs.Scroller;
      const active = this.$el.querySelector(".netpa-tab__link.active");
      if (!scroller || !active) return;
      const box = scroller.getBoundingClientRect();
      const tab = active.getBoundingClientRect();
      const pad = this.R * 2;
      if (tab.left - pad < box.left) {
        scroller.scrollLeft -= box.left - (tab.left - pad);
      } else if (tab.right + pad > box.right) {
        scroller.scrollLeft += tab.right + pad - box.right;
      }
    },
    OnShown() {
      this.Reveal();
      this.Sync();
    },
    // چرخ موس عمودی، نوار تب‌ها را افقی اسکرول می‌کند
    OnWheel(e) {
      const scroller = this.$refs.Scroller;
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      e.preventDefault();
      scroller.scrollLeft -= e.deltaY;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.Reveal();
      this.Sync();
      this.HintStart = setTimeout(this.PeekHint, 600);
    });
    window.addEventListener("resize", this.Sync);
    this.$refs.Scroller.addEventListener("scroll", this.Sync, { passive: true });
    this.$refs.Scroller.addEventListener("wheel", this.OnWheel, { passive: false });
    $(this.$el).on("show.bs.tab", this.OnShow);
    $(this.$el).on("shown.bs.tab", this.OnShown);
    if (window.ResizeObserver) {
      this.Observer = new ResizeObserver(this.Sync);
      this.Observer.observe(this.$el);
      this.Observer.observe(this.$el.querySelector(".netpa-tab__list"));
      this.Observer.observe(this.$refs.Actions);
      const header = this.GetHeader();
      if (header) this.Observer.observe(header);
    }
  },
  beforeDestroy() {
    clearTimeout(this.HintStart);
    clearTimeout(this.HintTimer);
    clearTimeout(this.PeekTimer);
    window.removeEventListener("resize", this.Sync);
    this.$refs.Scroller.removeEventListener("scroll", this.Sync);
    this.$refs.Scroller.removeEventListener("wheel", this.OnWheel);
    $(this.$el).off("show.bs.tab", this.OnShow);
    $(this.$el).off("shown.bs.tab", this.OnShown);
    if (this.Observer) this.Observer.disconnect();
  },
};
</script>
<style scoped>
.netpa-tab {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-border-default: #dbe5eb;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);

  position: relative;
  z-index: 2;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px 16px;
  padding: 0 4px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

.netpa-tab__strip {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}

/* تب‌هایی که جا نمی‌شوند با فلش، لمس، چرخ موس یا Tab کیبورد قابل اسکرول‌اند */
.netpa-tab__scroller {
  position: relative;
  /* جا برای خط بالای شکل و یک پیکسلی که روی border کارت می‌نشیند */
  margin: -1px 0;
  padding: 1px 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.netpa-tab__scroller::-webkit-scrollbar {
  display: none;
}

.netpa-tab__arrow {
  position: absolute;
  z-index: 3;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  width: 44px;
  margin: 0;
  padding: 0;
  color: var(--bnp-brand-navy);
  font-size: 12px;
  cursor: pointer;
  border: 0;
  background: transparent;
}

.netpa-tab__arrow i {
  display: flex;
  font-style: normal;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid var(--bnp-border-default);
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(41, 52, 95, 0.12);
  transition: background var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.netpa-tab__arrow:hover i {
  background: #f1f5f9;
}

.netpa-tab__arrow.is-hint i {
  animation: netpa-tab-pulse 1.2s var(--bnp-ease-standard) 2;
}

@keyframes netpa-tab-pulse {
  0% {
    box-shadow: 0 2px 6px rgba(41, 52, 95, 0.12), 0 0 0 0 rgba(5, 184, 200, 0.45);
  }
  70% {
    box-shadow: 0 2px 6px rgba(41, 52, 95, 0.12), 0 0 0 8px rgba(5, 184, 200, 0);
  }
  100% {
    box-shadow: 0 2px 6px rgba(41, 52, 95, 0.12), 0 0 0 0 rgba(5, 184, 200, 0);
  }
}

.netpa-tab__arrow:focus {
  outline: none;
}

.netpa-tab__arrow--right {
  right: 0;
  justify-content: flex-end;
  background: linear-gradient(to left, #fff 40%, rgba(255, 255, 255, 0));
}

.netpa-tab__arrow--left {
  left: 0;
  justify-content: flex-start;
  background: linear-gradient(to right, #fff 40%, rgba(255, 255, 255, 0));
}

/* ‌شکل تب فعال؛ خط دور آن با drop-shadow ساخته می‌شود و پایین آن خط ندارد */
.netpa-tab__shape {
  position: absolute;
  z-index: 0;
  pointer-events: none;
  filter: drop-shadow(1px 0 0 var(--bnp-border-default))
    drop-shadow(-1px 0 0 var(--bnp-border-default))
    drop-shadow(0 -1px 0 var(--bnp-border-default));
}

.netpa-tab__fill {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
  background-repeat: no-repeat;
}

.nav.netpa-tab__list {
  position: relative;
  z-index: 1;
  flex-wrap: nowrap;
  align-items: flex-end;
  width: max-content;
  min-width: 100%;
  margin: 0;
  padding: 0 36px;
  list-style: none;
  border: 0;
}

.netpa-tab__item {
  margin: 0;
}

.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  margin: 0;
  padding: 10px 26px;
  color: #5d6d82;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  border-radius: 14px 14px 0 0;
  background: transparent;
  box-shadow: none;
  transition: color var(--bnp-motion-fast) var(--bnp-ease-standard),
    background var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link:hover {
  color: var(--bnp-brand-navy);
  background: rgba(41, 52, 95, 0.05);
}

.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link.active,
.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link.active:hover,
.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link.active:focus {
  color: var(--bnp-brand-navy);
  font-weight: 800;
  background: transparent;
}

.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link:focus {
  outline: none;
}

.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.netpa-tab__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  padding-bottom: 10px;
}

.netpa-tab__actions:empty {
  display: none;
}

.netpa-tab.is-stacked {
  flex-wrap: wrap;
}

.netpa-tab.is-stacked .netpa-tab__actions {
  order: -1;
  width: 100%;
  padding-bottom: 0;
}

.netpa-tab.is-stacked .netpa-tab__strip {
  flex-basis: 100%;
}

@media (max-width: 767px) {
  .netpa-tab {
    flex-wrap: wrap;
  }

  .netpa-tab__actions {
    order: -1;
    width: 100%;
    padding-bottom: 0;
  }

  .netpa-tab__strip {
    flex-basis: 100%;
  }

  .nav.netpa-tab__list {
    padding: 0 32px;
  }

  .netpa-tab__item {
    flex: 1 0 auto;
  }

  .nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link {
    padding: 8px 14px;
    text-align: center;
  }
}

@media (prefers-reduced-motion: reduce) {
  .nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link {
    transition: none;
  }

  .netpa-tab__arrow.is-hint i {
    animation: none;
  }
}
</style>
